import React from "react";
import { Typography } from "@material-ui/core";
import {  ListItem, Li } from "./Components";
import ham_gas_haz_lev from "../img/sswpIcons/HarmfulGases/ham_gas_haz_lev.png";
import ham_gas_per_wor from "../img/sswpIcons/HarmfulGases/ham_gas_per_wor.png";
import ham_gas_sit_spe_met from "../img/sswpIcons/HarmfulGases/ham_gas_sit_spe_met.png";
import ham_gas_sur from "../img/sswpIcons/HarmfulGases/ham_gas_sur.png";
import ham_gas_ven from "../img/sswpIcons/HarmfulGases/ham_gas_ven.png";
export default {
    icon: ham_gas_haz_lev,
    name: "Harmful Gases",
    text: "",
    icons: {
        ham_gas_sur: {
            name: "Survey",
            icon: ham_gas_sur,
            text: (
                <ul>
                    <ListItem text="You can only survey in areas with sufficient lighting and visibility." />
                    <ListItem text="You should never survey while exposed to live traffic. You should have appropriate barriers, cones, safety zones etc in place." />
                    <ListItem text="The lateral safety zone from live traffic should be 0.5m when ≤ 60 km/h, and 1.2m when > 60 km/h. This includes while using the staff or target." />
                    <ListItem text="Select and implement an appropriate traffic management plan to provide you with a safe working area before commencing." />
                    <ListItem text="You must wear high visibility PPE (minimum Class 2)." />
                </ul>
            )
        },
        ham_gas_ven: {
            name: "Ventilation",
            icon: ham_gas_ven,
            text: (
                <ul>
                    <ListItem text="This control is where an engineered ventilation system is provided" />
                    <Li>
                        <Typography variant="title">
                            This can be of 2 types{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Negative Pressure Enclosures. This involves the building of an enclosure to contain the substance, gas, agent. Negative pressure units are installed within the enclosure to ensure all air flows into the enclosure, and that contained air cannot escape. It is often used for asbestos." />
                            <ListItem text="Local Exhaust Ventilation (LEV). This is an engineered system that captures harmful substances locally, at the emission point. It is often used for fumes, dust, spray." />
                        </ol>
                    </Li>
                    <ListItem text="The system needs to be installed by a competent person and certify that it is fit for purpose and for the intended emissions. It will require a thorough examination at least every 14 months, or shorter if specified by manufacturer." />
                    <ListItem text=" Negative Pressure enclosures must be operated to a strict and site specific method statement. They require a permit to enter system. Workers will have to undergo a decontamination procedure on leaving the enclosure." />
                    <ListItem text="Where LEVs are provided, they must be used by workers. The hood must be large enough, and the extraction air flow strong enough, to capture the emission. LEV hoods must be positioned by the worker to entrain/contain the emission at source. They should have an airflow meter that indicates correct operation. This must be checked by the worker before beginning the task. As a rule, at one ducting diameter distance from the opening, the air flow will be reduced to 10% of the total volume." />
                    <ListItem text="Workers must be clear on the limitation of LEVs and the requirement for other risk controls selected, including breathing PPE." />
                    <ListItem text="For Large system LEVs (where workers are within a ventilation zone), work should be organised such that the worker’s body, or other solid objects, are NOT placed in the air flow path, as this will obstruct flow and generate dead areas." />
                    <ListItem text="The ducting for both systems needs regular visual inspection, for damage, denting, couplings, or leaks. Filters should also be inspected regularly and replaced/cleaned in accordance with the manufacturer instructions." />
                </ul>
            )
        },
        ham_gas_per_wor: {
            name: "Permit To Work",
            icon: ham_gas_per_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        ham_gas_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: ham_gas_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
